import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const AGENDA_PATHS = ['/', '/agenda'];

export const isAgendaPath = (pathname: string) => AGENDA_PATHS.includes(pathname.replace(/(.)\/+$/, '$1'));

// No modo compacto, os modulos fora da Agenda abrem em tela cheia, sem o header global do app.
export function useModuleSheet() {
    const { pathname } = useLocation();
    const isCompactMenu = useMediaQuery({ maxWidth: 1024 });
    return isCompactMenu && !isAgendaPath(pathname);
}
